(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({behavior: 'instant'});
      }
    }, {once: true});
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bookEyeExam = document.querySelector('.slideshow__book-eye-exam');
    if (!bookEyeExam) return;

    const footer = document.querySelector('footer') ?? document.querySelector('[class*="footer-group"]');
    if (!footer) return;

    const MOBILE_BREAKPOINT = 1024;

    let isMobile = window.innerWidth < MOBILE_BREAKPOINT;
    let observer = null;

    function setupObserver() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }

      if (!isMobile) {
        bookEyeExam.classList.remove('slideshow__book-eye-exam--hidden');
        document.body.classList.remove('book-eye-exam-visible');
        return;
      }

      observer = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;
          if (!entry) return;

          if (entry.isIntersecting) {
            bookEyeExam.classList.add('slideshow__book-eye-exam--hidden');
            document.body.classList.remove('book-eye-exam-visible');
          } else {
            bookEyeExam.classList.remove('slideshow__book-eye-exam--hidden');
            document.body.classList.add('book-eye-exam-visible');
          }
        },
        {
          rootMargin: '0px 0px 0px 0px',
          threshold: 0,
        }
      );

      observer.observe(footer);
    }

    // Initial setup
    setupObserver();

    // Re-evaluate on resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const wasMobile = isMobile;
        isMobile = window.innerWidth < MOBILE_BREAKPOINT;

        if (wasMobile !== isMobile) {
          setupObserver();
        }
      }, 150);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
